<template>
  <button
    class="btn button-green px-5"
    style="width: 100%"
    @click="onSubmitBtn()"
  >
    {{ $t("TXT_SAVE") }}
  </button>
</template>
<script>
export default {
  methods: {
    onSubmitBtn() {
      this.$emit("onSubmitBtn");
    },
  },
};
</script>
